import configuration from './../config.json'
import CarsBrandsService from './../shared/services/carsBrandsService'
import CookieService from './../shared/services/cookiesService'
import { setLogout } from './authActions'

const RESPONSE_CARS_BRANDS = 'RESPONSE_CARS_BRANDS'
const REQUEST_CARS_BRANDS_FAILURE = 'REQUEST_CARS_BRANDS_FAILURE'

const responseGetCarsBrandsAction = (data) => {
  return {
    type: RESPONSE_CARS_BRANDS,
    data,
  }
}

const requestGetCarsBrandsfailureAction = (errors) => {
  return {
    type: REQUEST_CARS_BRANDS_FAILURE,
    errors,
  }
}

const getCarsBrands = () => {
  return (dispatch) => {
    CarsBrandsService.getCarsBrands()
      .then((result) => {
        CookieService.updateExpires(configuration.cookieName, 12)

        dispatch(responseGetCarsBrandsAction(result.data.brands))
      })
      .catch((error) => {
        dispatch(requestGetCarsBrandsfailureAction(error.response))

        if (error.response && error.response.status === 401) {
          dispatch(setLogout())
        }
      })
  }
}

export {
  getCarsBrands,
  responseGetCarsBrandsAction,
  requestGetCarsBrandsfailureAction,
  RESPONSE_CARS_BRANDS,
  REQUEST_CARS_BRANDS_FAILURE,
}
